<template>
  <transition name="fade">
    <div
      class="bank_picker__modal-mask"
      v-if="isActive"
      v-on:click.self="closeBankPicker"
    >
      <div class="bank_picker__modal_content_container">
        <div class="bank_picker__modal_content_wrapper">
          <nav class="bank_picker__navigation">
            <div
              class="bank_picker__back"
              v-if="needsShowBackButton"
              v-on:click="onClickBackButton"
            >
              <img src="/img/disclosure-indicator-back.svg" />
            </div>
            <p class="bank_picker__title">{{ pickerSetTitle }}</p>
            <img
              class="bank_picker__close"
              v-on:click="closeBankPicker"
              src="/img/close-black.svg"
            />
          </nav>
          <transition name="slide-fade" mode="in-out">
            <section
              class="bank_picker__picker_set"
              v-if="
                pickerSetIndex ==
                PICKER_SET_INDEX.MAJOR_BANKS_AND_BANK_NAME_INITIAL_GROUPS
              "
            >
              <ListSubheader
                title="主要金融機関"
                v-bind:subheaderStyle="listSubheaderStyle"
              />
              <div
                class="bank_picker__list_row"
                v-for="(bank, index) in MAJOR_BANKS"
                :key="`bank_${index}`"
              >
                <ListItem
                  v-bind:title="bank.bank_name"
                  v-on:click.native="selectBank(bank)"
                  v-bind:itemStyle="listItemStyle"
                />
              </div>
              <ListSubheader
                title="50音順"
                v-bind:subheaderStyle="listSubheaderStyle"
              />
              <div
                class="bank_picker__list_row"
                v-for="(initialGroup, index) in BANK_NAME_INITIAL_GROUPS"
                :key="`initial_group_${index}`"
              >
                <ListItem
                  v-bind:title="initialGroup.name"
                  v-on:click.native="selectBankNameInitialGroup(initialGroup)"
                  v-bind:hasDisclosure="true"
                  v-bind:itemStyle="listItemStyle"
                />
              </div>
            </section>
          </transition>
          <transition name="slide-fade" mode="in-out">
            <section
              v-if="pickerSetIndex == PICKER_SET_INDEX.BANK_NAME_INITIALS"
            >
              <div
                class="bank_picker__list_row"
                v-for="(initial, index) in bankNameInitials"
                :key="`initial_${index}`"
              >
                <ListItem
                  v-bind:title="initial.body"
                  v-on:click.native="selectBankNameInitial(initial)"
                  v-bind:hasDisclosure="true"
                  v-bind:itemStyle="listItemStyle"
                />
              </div>
            </section>
          </transition>
          <transition name="slide-fade" mode="in-out">
            <section
              v-if="pickerSetIndex == PICKER_SET_INDEX.BANKS_SEARCH_BY_INITIAL"
            >
              <div
                class="bank_picker__list_row"
                v-for="(bank, index) in banksSearchByInitial"
                :key="`bank_search_${index}`"
              >
                <ListItem
                  v-bind:title="bank.bank_name"
                  v-on:click.native="selectBank(bank)"
                  v-bind:itemStyle="listItemStyle"
                />
              </div>
            </section>
          </transition>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { MajorBanks, BankNameInitialGroups } from '@/utils/MasterBank'
import { PICKER_SET_INDEX } from '@/store/modules/components/bankPicker'
import { mapGetters, mapState, mapActions } from 'vuex'
import ListItem from '@/components/ListItem'
import ListSubheader from '@/components/ListSubheader'
export default {
  name: 'BankPicker',
  components: {
    ListItem,
    ListSubheader,
  },
  data: function () {
    return {
      MAJOR_BANKS: MajorBanks,
      BANK_NAME_INITIAL_GROUPS: BankNameInitialGroups,
      PICKER_SET_INDEX: PICKER_SET_INDEX,
      listItemStyle: {},
      listSubheaderStyle: {},
    }
  },
  computed: {
    ...mapState({
      isActive: (state) => state.components.bankPicker.isActive,
      banksSearchByInitial: (state) =>
        state.components.bankPicker.banksSearchByInitial,
      pickerSetIndex: (state) => state.components.bankPicker.pickerSetIndex,
    }),
    ...mapGetters('components/bankPicker', [
      'needsShowBackButton',
      'bankNameInitials',
      'pickerSetTitle',
    ]),
  },
  methods: {
    ...mapActions('components/bankPicker', [
      'selectBankNameInitialGroup',
      'selectBankNameInitial',
      'selectBank',
      'onClickBackButton',
      'closeBankPicker',
    ]),
  },
}
</script>

<style scoped>
.bank_picker__modal-mask {
  position: fixed;
  overflow: hidden;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(38, 38, 38, 0.35);
  display: flex;
  justify-content: center;
  align-items: center;
}
.bank_picker__modal_content_container {
  position: relative;
  height: 520px;
  margin-left: 15px;
  margin-right: 15px;
  width: 100%;
  background: #ffffff;
  overflow: hidden;
  border-radius: 8px;
  z-index: 1;
}

.bank_picker__modal_content_wrapper {
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.bank_picker__navigation {
  width: 100%;
  height: 57px;
  padding-top: 2px;
  background-color: #ffffff;
  border-radius: 8px 8px 0 0;
  box-shadow: 0 0.5px 0 0 rgba(0, 0, 0, 0.1);
  border-bottom: #e8e8e8 1px solid;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  position: sticky;
  position: -webkit-sticky;
  left: 0;
  top: 0;
  z-index: 1;
}

.bank_picker__title {
  font-family: sans-serif;
  font-size: 17px;
  font-weight: bold;
  text-align: center;
  color: #262626;
}

.bank_picker__back {
  display: flex;
  position: absolute;
  align-items: center;
  flex-direction: row;
  left: 0;
  font-family: sans-serif;
  font-size: 14px;
  line-height: 1.43;
  color: #1aa7ff;
  cursor: pointer;
  pointer-events: auto;
}

.bank_picker__back img {
  height: 44px;
}

.bank_picker__back:after {
  content: '戻る';
  margin-left: -8px;
}

.bank_picker__list_row {
  cursor: pointer;
}

.bank_picker__close {
  position: absolute;
  right: 15px;
  cursor: pointer;
  pointer-events: auto;
}

.bank_picker__picker_set {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.03s ease;
}
.slide-fade-leave-active {
  transition: all 0.02s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
